import { Timestamp, Query, query, where, orderBy } from 'firebase/firestore';
import { IFutureOrder, FutureOrderExposure } from '../sp-types/FutureOrderType';
import { getItems, saveItem } from './genericFB';

const FUTURE_ORDER_EXPOSURE = 'future-orders-exposure';

export const saveFutureOrderExposures = async ({
  accountId,
  uuid,
  monthExposure,
}: IFutureOrder): Promise<(FutureOrderExposure | null)[] | null> => {
  if (uuid && monthExposure) {
    const exposureRecords = Object.entries(monthExposure || {}).flatMap(([materialId, exposureCalendar]) =>
      (exposureCalendar || []).map(
        ({ date: exposeMonth, value: exposureValue }) =>
          ({
            uuid: `${accountId}_${uuid}_${materialId}_${exposeMonth.year}-${exposeMonth.month}`,
            orderId: uuid,
            accountId,
            materialId,
            exposeMonth,
            exposureValue,
            exposureDate: Timestamp.fromDate(new Date(exposeMonth.year, exposeMonth.month - 1, 1)),
          } as FutureOrderExposure),
      ),
    );

    const results = await Promise.all(
      exposureRecords.map((record) => saveItem<FutureOrderExposure>(record.uuid, record, FUTURE_ORDER_EXPOSURE)),
    );

    return results.filter(Boolean);
  }

  return null;
};

export const getFutureExposure = async (
  accountId: string,
  fromDate?: Date,
): Promise<FutureOrderExposure[] | undefined> => {
  return getItems<FutureOrderExposure>(accountId, FUTURE_ORDER_EXPOSURE, (q: Query) =>
    query(
      q,
      fromDate ? where('exposureDate', '>=', Timestamp.fromDate(fromDate)) : where('accountId', '==', accountId),
      orderBy('exposureDate', 'asc'),
    ),
  );
};
